import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faUsers } from "@fortawesome/free-solid-svg-icons"

export const Users = (props) => {
  return <FontAwesomeIcon faIcon={faUsers} {...props} />
}
